import type { Article } from "./types";

export const giftRegistryAndOnlineContributions: Article = {
  slug: "gift-registry-and-online-contributions",
  published: true,
  publishedAt: "2026-10-06",
  updatedAt: "2026-10-06",
  title: {
    ro: "Lista de cadouri și contribuțiile online",
    en: "The gift list and online contributions",
  },
  summary: {
    ro: "Cum adaugi cadouri pe pagina evenimentului, cum alegi dacă lista apare în invitație și cum primești contribuții online prin Stripe.",
    en: "How to add gifts to the event page, choose whether the list appears in the invitation, and receive online contributions through Stripe.",
  },
  body: {
    ro: [
      { t: "p", text: "Lista de cadouri le arată invitaților ce cadou îți dorești sau ce experiență pot susține. Darul online este opțional: invitații pot contribui online dacă doresc." },
      { t: "h2", text: "Adaugă cadourile" },
      { t: "p", text: "În tab-ul „Cadouri” din editorul evenimentului apeși „Adaugă cadou”. Pentru fiecare cadou poți completa:" },
      {
        t: "ul",
        items: [
          "„Numele cadoului” și o descriere;",
          "un „Link produs” către magazin;",
          "o „Sumă țintă”, ca să vezi cât s-a strâns pentru acel cadou.",
        ],
      },
      { t: "p", text: "Opțiunea „Afișează în registru” îți permite să ascunzi un cadou cât timp lucrezi încă la detalii." },
      { t: "h2", text: "Afișează sau ascunde lista" },
      { t: "p", text: "În tab-ul „Pagina Eveniment”, opțiunea „Lista de cadouri” stabilește dacă lista apare în invitație. Dacă o dezactivezi, secțiunea de cadouri dispare complet din invitație." },
      { t: "h2", text: "Contribuții online prin Stripe" },
      { t: "p", text: "Pentru a primi contribuții online, conectezi un cont Stripe din meniul contului, la „Cont Stripe Conectat”. Configurarea (onboarding-ul) este gestionată de Stripe." },
      { t: "p", text: "Invitații contribuie cu cardul direct de pe pagina evenimentului, fără să-și facă un cont. Plățile sunt procesate de Stripe, iar contribuțiile ajung direct în contul tău Stripe conectat." },
      { t: "p", text: "Contribuțiile confirmate prin plată apar în tab-ul „Cadouri”, la „Contribuții recente”. De acolo poți rambursa o contribuție, integral sau parțial." },
      { t: "p", text: "Funcțiile de cadouri disponibile depind de pachetul evenimentului." },
    ],
    en: [
      { t: "p", text: "The gift list shows guests which gifts you would like or which experiences they can contribute to. Giving online is optional: guests can contribute online if they want." },
      { t: "h2", text: "Add the gifts" },
      { t: "p", text: "In the “Gifts” tab of the event editor, click “Add gift”. For each gift you can fill in:" },
      {
        t: "ul",
        items: [
          "the “Gift name” and a description;",
          "a “Product link” to the shop;",
          "a “Target amount”, so you can see how much has been raised for that gift.",
        ],
      },
      { t: "p", text: "The “Display gift on registry” option lets you hide a gift while you are still preparing its details." },
      { t: "h2", text: "Show or hide the list" },
      { t: "p", text: "In the “Event Landing Page” tab, the “Gift list” option decides whether the list appears in the invitation. If you turn it off, the gift section disappears from the invitation entirely." },
      { t: "h2", text: "Online contributions through Stripe" },
      { t: "p", text: "To receive online contributions, connect a Stripe account from the account menu, under “Stripe Connected Account”. The setup (onboarding) is handled by Stripe." },
      { t: "p", text: "Guests contribute by card right from the event page, without creating an account. Payments are processed by Stripe, and contributions go directly to your connected Stripe account." },
      { t: "p", text: "Contributions confirmed by payment appear in the “Gifts” tab, under “Recent Contributions”. From there you can refund a contribution, in full or in part." },
      { t: "p", text: "The gift features available depend on the event's plan." },
    ],
  },
};
